import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=452b921e&"
import script from "./Tags.vue?vue&type=script&lang=js&"
export * from "./Tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452b921e')) {
      api.createRecord('452b921e', component.options)
    } else {
      api.reload('452b921e', component.options)
    }
    module.hot.accept("./Tags.vue?vue&type=template&id=452b921e&", function () {
      api.rerender('452b921e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Tags.vue"
export default component.exports